import { render, staticRenderFns } from "./SubmitFirst.vue?vue&type=template&id=38806798&scoped=true"
import script from "./SubmitFirst.vue?vue&type=script&lang=js"
export * from "./SubmitFirst.vue?vue&type=script&lang=js"
import style0 from "./SubmitFirst.vue?vue&type=style&index=0&id=38806798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38806798",
  null
  
)

export default component.exports